import { useUserContext } from '@/auth/UserContext';

export const useHasFamilySubscription = (): boolean => {
  const { user } = useUserContext();

  return user?.premiumSubscription?.isActive === true;
};
